import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'other_types_required_leave_1'

export const dataPointDefinition = {
  retracedId: 'other_types_required_leave_1',
  name: 'Other types of required leave',
  description:
    '"Other types of required leave" refers to other types of leave legally required not listed above. Consult applicable legal requirements to determine entitlements to, accrual of, and ability to take leave.�',
  meta: {
    slcpMeta: {
      key: 'wb-wag-76',
      number: 'WH-WOR-25-11',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wag-76', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35750,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
